/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import JPEGJS from 'jpeg-js'
import PNGJS from 'pngjs'

function readFile (file) {
  return new Promise((resolve) => {
    let reader = new FileReader()
    reader.onload = async function (e) {
      let orientation = ((e) => {
        var view = new DataView(e.target.result);
        if (view.getUint16(0, false) != 0xFFD8)
          return 1;
        var length = view.byteLength, offset = 2;
        while (offset < length) 
        {
            if (view.getUint16(offset+2, false) <= 8) break;
            var marker = view.getUint16(offset, false);
            offset += 2;
            if (marker == 0xFFE1) 
            {
                if (view.getUint32(offset += 2, false) != 0x45786966) 
                    return 1;

                var little = view.getUint16(offset += 6, false) == 0x4949;
                offset += view.getUint32(offset + 4, little);
                var tags = view.getUint16(offset, little);
                offset += 2;
                for (var i = 0; i < tags; i++)
                {
                    if (view.getUint16(offset + (i * 12), little) == 0x0112)
                    {
                        return view.getUint16(offset + (i * 12) + 8, little);
                    }
                }
            }
            else if ((marker & 0xFF00) != 0xFF00)
                break;
            else
                offset += view.getUint16(offset, false);
        }
        return 1;
      })(e)
      
      resolve({arrayBuffer: e.target.result, orientation})
    }
    reader.readAsArrayBuffer(file)
  })
}

function transpose(res) {
  let pixelData = new Uint8Array(res.pixelData.length)

  const channels = 4
  const step = res.width * channels
  let i = 0
  for (let col = 0; col < res.width; col++) {
    const colStep = col * channels
    for (let row = 0; row < res.height; row++) {
      let index = row * step + colStep
      for (let channel = 0; channel < channels; channel++)
        pixelData[i++] = res.pixelData[index + channel]
    }
  }

  let t = res.width
  res.width = res.height
  res.height = t
  res.pixelData = pixelData
}

function hflip(res) {
  const cols = parseInt(res.width / 2)
  const channels = 4
  const step = res.width * channels
  for (let row = 0; row < res.height; row++) {
    const rowStep = row * step
    for (let col = 0; col < cols; col++) {
      const index1 = rowStep + col * channels
      const index2 = rowStep + (res.width - col) * channels
      for (let channel = 0; channel < channels; channel++) {
        const t = res.pixelData[index2 + channel]
        res.pixelData[index2 + channel] = res.pixelData[index1 + channel]
        res.pixelData[index1 + channel] = t
      }
    }
  }
}

function vflip(res) {
  const rows = parseInt(res.height / 2)
  const channels = 4
  const step = res.width * channels
  for (let row = 0; row < rows; row++) {
    for (let col = 0; col < res.width; col++) {
      const colStep = col * channels
      const index1 = row * step + colStep
      const index2 = (res.height - row) * step + colStep
      for (let channel = 0; channel < channels; channel++) {
        const t = res.pixelData[index2 + channel]
        res.pixelData[index2 + channel] = res.pixelData[index1 + channel]
        res.pixelData[index1 + channel] = t
      }
    }
  }
}

function parseJpg (arrayBuffer) {
  return new Promise(function (resolve, reject) {
    try {
      const byteArray = new Uint8Array(arrayBuffer)
      const data = JPEGJS.decode(byteArray, true)

      resolve({pixelData: data.data, width: data.width, height: data.height})
    } catch (err) {
      reject(err)
    }
  })
}

function parsePng (arrayBuffer) {
  return new Promise(function (resolve, reject) {
    const byteArray = new Uint8Array(arrayBuffer)
    new PNGJS.PNG({filterType: 4}).parse(byteArray, async function (error, data) {
      try {
        if (error != null)
          reject(error)

        resolve({pixelData: data.data, width: data.width, height: data.height})
      } catch (err) {
        reject(err)
      }
    })
  })
}

function encodeJpg (pixelData, width, height) {
  return JPEGJS.encode({data: pixelData, width, height}, 90).data
}

function encodePng (pixelData, width, height) {
  let png = new PNGJS.PNG({width: width, height: height})
  for (let row = 0; row < height; row++) {
    for (let col = 0; col < width; col++) {
      const idx = (width * row + col) << 2
      
      png.data[idx] = pixelData[idx]
      png.data[idx + 1] = pixelData[idx + 1]
      png.data[idx + 2] = pixelData[idx + 2]
      png.data[idx + 3] = pixelData[idx + 3]
    }
  }

  const encoded = PNGJS.PNG.sync.write(png)
  return encoded
}

function encodeImage (name, pixelData, width, height) {
  const tokens = name.split('.')
  const ext = tokens[tokens.length - 1].toLowerCase()

  let encoded = null
  if (ext.toLowerCase().endsWith('jpg') || ext.toLowerCase().endsWith('jpeg')) {
    encoded = encodeJpg(pixelData, width, height)
  } else if(ext.toLowerCase().endsWith('png')) {
    encoded = encodePng(pixelData, width, height)
  } else {
    throw new Error('unsupported extension')
  }

  return new File([encoded], name)
}

function _base64ToArrayBuffer2(base64) {
  var binary_string = window.atob(base64);
  var len = binary_string.length;
  var bytes = new Uint8Array(len);
  for (var i = 0; i < len; i++) {
    bytes[i] = binary_string.charCodeAt(i);
  }
  return bytes;
}

function _base64ToArrayBuffer(base64, optical) {
  var binary_string = window.atob(base64);
  var len = binary_string.length;
  var bytes = new Uint8Array(len/3*4);
  for (var i = 0; i < len; i++) {
    var result = parseInt(i / 3);
    var remainder = i % 3;
    bytes[result*4 + remainder] = binary_string.charCodeAt(i);
  }
  for (let i = 3; i < bytes.length; i += 4) {
    bytes[i] = 255
  }
  return bytes;
}

async function parseBase64 (base64, width, height, ext) {  
  if (typeof(ext) != 'string') {
    throw new Error('extension must be a type of string')
  }
  if (ext.toLowerCase().endsWith('jpg') || ext.toLowerCase().endsWith('jpeg')) {
    const byteArray = new Uint8Array(_base64ToArrayBuffer2(base64))
    const data = JPEGJS.decode(byteArray, true)

    return {pixelData: data.data, width: data.width, height: data.height}
  } else if(ext.toLowerCase().endsWith('png')) {
    return {pixelData: _base64ToArrayBuffer(base64), width: width, height: height}
  } else {
    throw new Error('unsupported extension')
  }
}

async function parseImage (blob, ext) {
  if (!(blob instanceof Blob)) {
    throw new Error('blob must be a instance of Blob')
  }
  if (typeof(ext) != 'string') {
    throw new Error('extension must be a type of string')
  }
  let res
  if (ext.toLowerCase().endsWith('jpg') || ext.toLowerCase().endsWith('jpeg')) {
    const {arrayBuffer, orientation} = await readFile(blob)
    res = await parseJpg(arrayBuffer)
    if (orientation == 8) {
      transpose(res)
      vflip(res)
    }
    else if (orientation == 3) {
      vflip(res)
      hflip(res)
    }
    else if (orientation == 6) {
      transpose(res)
      hflip(res)
    }
  } else if(ext.toLowerCase().endsWith('png')) {
    const {arrayBuffer, orientation} = await readFile(blob)
    res = await parsePng(arrayBuffer)
  } else {
    throw new Error('unsupported extension')
  }
  return res
}

export default {
  parseImage,
  parsePng,
  parseJpg,
  parseBase64,
  encodeImage
}
